
	import { accountList, accountDefault, delAccount } from "@/api/member/member"
	export default {
	    name: "account_list",
	    components: {},
	    data: () => {
	        return {
				dataList: [],
				total: 0,
				currentPage: 1,
				pageSize: 8,
				loading: true,
				isSub: false,
				yes: true
	        }
	    },
	    created() {
			this.back = this.$route.query.back
			this.getAccountList()
	    },
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false
			}, 300)
		},
	    methods: {
	        handlePageSizeChange(size) {
	            this.pageSize = size
	            this.refresh()
	        },
	        handleCurrentPageChange(page) {
	            this.currentPage = page
	            this.refresh()
	        },
	        refresh() {
	            this.loading = true
	            this.getAccountList()
	        },
			/**
			 * 獲取賬戶列表
			 */
			getAccountList() {
				accountList({
					page_size: this.pageSize,
					page: this.currentPage
				}).then(res => {
					this.dataList = res.data.list
					this.total = res.data.count
					
					let withdrawType = {
						'bank': '銀行',
						'alipay': '支付寶',
						'wechatpay': '微信'
					};
					this.dataList.forEach(item => {
						item.withdraw_type_name = withdrawType[item.withdraw_type] ? withdrawType[item.withdraw_type] : '';
					})
					
					this.loading = false
				}).catch(err => {
					this.loading = false
				})
			},
			setDefault(id) {
				if (this.isSub) return;
				this.isSub = true;
				
				accountDefault({
					id: id
				}).then(res => {
					if (this.back) {
						this.$router.push(this.back);
					} else {
						this.refresh()
						this.$message.success('修改默認賬戶成功')
					}
					this.isSub = false;
				}).catch(err => {
					this.isSub = false;
					this.$message.error(err.message)
				})
			},
			delAccount(id) {
				this.$confirm("確定要刪除該賬戶嗎?", "提示", {
				    confirmButtonText: "確定",
				    cancelButtonText: "取消",
				    type: "warning"
				}).then(() => {
				    delAccount({
				        id: id
				    }).then(res => {
						this.refresh()
						this.$message.success(res.message)
					}).catch(err => {
						this.$message.error(err.message)
					})
				})
			},
			/**
			 * 添加/編輯地址
			 */
			addAccount(type, id) {
			    if (type == "edit") {
			        this.$router.push({ path: "/member/account_edit", query: { id: id } })
			    } else {
			        this.$router.push({ path: "/member/account_edit" })
			    }
			},
	    }
	}
